// "Sort by" on the Fee Slips & Invoices tab. The list stays grouped by status; this orders
// the fee slips inside each group, and the printed selection follows the same order.
//
// Dates are when the item reached the portal - an email's received time, a statement's
// upload, a fee slip's creation. Clerk statements give one date per statement, not per
// invoice, so lines from the same statement keep their client order between themselves.

const text = (value) => String(value ?? "");
const amountOf = (item) => Number.parseFloat(item?.invoiceAmount) || 0;
const timeOf = (item) => {
  const time = Date.parse(text(item?.uploadedAt));
  return Number.isFinite(time) ? time : 0;
};
// Invoice numbers compared as numbers where they are numbers: 00949041 before 00949042,
// and 99 before 100.
const invoiceOf = (item) => text(item?.invoiceRef || item?.invoiceName).replace(/^0+(?=\d)/, "");

const byClient = (a, b) => text(a.clientName).localeCompare(text(b.clientName), "en-AU", { sensitivity: "base" });

export const FEE_SLIP_SORTS = [
  { value: "client", label: "Client (A–Z)", compare: byClient },
  { value: "amount_desc", label: "Amount (highest first)", compare: (a, b) => amountOf(b) - amountOf(a) || byClient(a, b) },
  { value: "amount_asc", label: "Amount (lowest first)", compare: (a, b) => amountOf(a) - amountOf(b) || byClient(a, b) },
  { value: "newest", label: "Date received (newest first)", compare: (a, b) => timeOf(b) - timeOf(a) || byClient(a, b) },
  { value: "oldest", label: "Date received (oldest first)", compare: (a, b) => timeOf(a) - timeOf(b) || byClient(a, b) },
  {
    value: "invoice",
    label: "Invoice number",
    compare: (a, b) => invoiceOf(a).localeCompare(invoiceOf(b), "en-AU", { numeric: true }) || byClient(a, b),
  },
  {
    value: "barrister",
    label: "Barrister (A–Z)",
    compare: (a, b) => text(a.counselName).localeCompare(text(b.counselName), "en-AU", { sensitivity: "base" }) || byClient(a, b),
  },
];

export const DEFAULT_FEE_SLIP_SORT = "client";

export function feeSlipComparator(value) {
  return (FEE_SLIP_SORTS.find((option) => option.value === value) || FEE_SLIP_SORTS[0]).compare;
}
